import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import { DATA_SOURCES_TEST_PREFIX } from "../Utils";
import { Checkbox } from "@theorgchartdev/storybook";
import { appcstr } from "@coreapp/utils/appcstr";

export const SalesforceSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const { sandbox } = config;

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
    >
      <Checkbox
        id={"toggle-sandbox"}
        data-testid={`${DATA_SOURCES_TEST_PREFIX}-salesforce-sandbox-checkbox`}
        label={appcstr("sfsandbox")}
        size={"small"}
        checked={sandbox}
        onChange={() => onChange({ ...config, sandbox: !sandbox })}
      />
    </DataSourceSetupComposite>
  );
};
